module.exports = __webpack_public_path__ + "media/images/lp_cv-hukidashi-a83630b1e9d266bdebd767b8d714e46f.webp";